import type { JsonRpcError } from '../types.js';

export type ClientErrorKind =
  | 'connection'
  | 'timeout'
  | 'api-auth'
  | 'encryption-required'
  | 'pairing-rejected'
  | 'device-api'
  | 'unsupported'
  | 'rate-limit'
  | 'protocol';

export class ClientError extends Error {
  constructor(
    readonly kind: ClientErrorKind,
    message: string,
    readonly details?: unknown,
  ) {
    super(message);
    this.name = 'ClientError';
  }
}

export class RpcError extends ClientError {
  readonly rpc: JsonRpcError;

  constructor(rpc: JsonRpcError) {
    super(rpc.code === -32601 ? 'unsupported' : 'device-api', rpc.message, rpc.data);
    this.name = 'RpcError';
    this.rpc = rpc;
  }
}

export function connectionError(message: string, details?: unknown): ClientError {
  return new ClientError('connection', message, details);
}

export function timeoutError(message: string): ClientError {
  return new ClientError('timeout', message);
}
